import { LocationId } from '../../../location/Location';

export type * from './FacebookPagePost';
export type * from './FacebookPagePostThirdPartyResource';
export * from './WithFacebookCursorPagination';
export * from './metrics';
export type * from './reporting';
export * from './types';
export * from './utils';

export interface FacebookPostStatsEntry {
    postId: string; // Replaced ID
    pageId: string;
    pageName: string;
    locationTitle: string;
    locationId: LocationId;
    type: string;
    picture: string;
    storyAddsUnique: number | null;
    impressionsUnique: number;
    impressionsPaidUnique: number;
    paidMediaViews: number | null;
    consumptionsUnique: number;
    date: Date;
    positiveFeedback: number | null;
    totalMediaViews: number | null;
}

export interface PostRankings {
    reach: FacebookPostStatsEntry[];
    consumptions: FacebookPostStatsEntry[];
    positiveFeedback: FacebookPostStatsEntry[];
}

export interface PostRankingsGroups {
    organic: PostRankings;
    paid: PostRankings;
}

export interface FacebookStatsCount {
    count: number;
}

export interface FacebookStatsLikes extends FacebookStatsCount {
    previous: number;
    new: number;
    growth: number;
}

export interface FacebookStatsPosts extends FacebookStatsCount {
    insights: PostRankingsGroups;
}

export interface FacebookStatsEngagement {
    consumptions: number;
    reach: number;
}

export interface FacebookStatsForLocation {
    likes: FacebookStatsLikes;
    posts: FacebookStatsPosts;
    consumptions: FacebookStatsCount;
    positiveFeedback: FacebookStatsCount;
    reach: FacebookStatsCount;
    clickRate: FacebookStatsCount;
    engagement: FacebookStatsEngagement;
}

export const facebookMinimumScheduleTime = 10;
